<div class="shop-summary">
  <no-result *ngIf="isListEmpty && isLoggedIn"></no-result>
  <div class="none-logged flex" *ngIf="!isLoggedIn">
    <img src="assets/images/icons/lock.svg" alt="Lock Icon" />
    <p class="title">Feature Access</p>
    <p class="description">Log in to access your kingiftcard order history</p>
    <button
      class="button primary-button"
      [routerLink]="['/authenticate', 'login']"
    >
      Log In
    </button>
  </div>
  <ng-container *ngIf="isLoggedIn">
    <div
      class="page-title ms-padding"
      *ngIf="products?.length || isFilterFormCalled"
    >
      <p>Order List:</p>
      <button
        type="button"
        class="button warn-button"
        (click)="isDesktop ? openFilterDialog() : openBottomSheet()"
      >
        <img src="assets/images/icons/filter.svg" alt="" /> <span>Filter</span>
      </button>
    </div>
    <div class="tab-content" *ngIf="!isDesktop">
      <div class="order-card" *ngFor="let product of products">
        <div class="order ms-padding">
          <div class="flex">
            <p class="order-title">
              {{ product?.product_detail?.name }}
              {{ product?.product_detail?.currency_detail?.symbol
              }}{{ product?.item_price | convertPrice }}
            </p>
            <div class="flex order-detail">
              <img
                src="assets/images/icons/eye.svg"
                alt=""
                (click)="openProductDetail(product)"
                class="pointer"
              />
            </div>
          </div>
          <div class="flex">
            <p class="order-info">Order ID:</p>
            <p>#{{ product?.order_code }}</p>
          </div>
          <div class="flex">
            <p class="order-info">Date:</p>
            <p>{{ product?.created_time | date : "yyyy.MMM.dd hh:mm a" }}</p>
          </div>
          <div class="flex">
            <p class="order-info">Status:</p>
            <div
              class="status-box"
              [ngClass]="{
                'red-status': product.status == -1,
                'green-status': product.status == 6,
                'pending-status': product.status == 5
              }"
            >
              {{ product?.status_display }}
            </div>
          </div>
          <div class="flex order-actions" *ngIf="product.status != 5 && product.status != 3 && product.status != 8">
            <ng-container *ngIf="product.status != -1">
              <img
                class="pointer"
                src="assets/images/icons/copy-blue.svg"
                alt=""
                (click)="viewOrder(product?.id, 1)"
              />
              <button
                class="outline-button"
                type="button"
                (click)="retryOrder(product)"
              >
                <span>Order Again</span>
              </button>
              <button
                class="primary-button view-order-button"
                type="button"
                (click)="viewOrder(product?.id, 2)"
              >
                <span>View Card</span>
              </button>
            </ng-container>
            <button
              class="outline-button"
              type="button"
              *ngIf="product.status == -1"
              (click)="retryOrder(product)"
            >
              <img src="assets/images/icons/reload-blue.svg" alt="" />
              <span>Try Again</span>
            </button>
          </div>
        </div>
        <hr class="custom-hr" />
      </div>
    </div>
    <table
      mat-table
      [dataSource]="products"
      class="order-history-table w-full"
      *ngIf="isDesktop && !isListEmpty"
    >
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.product_detail?.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="order_id">
        <th mat-header-cell *matHeaderCellDef>Order ID</th>
        <td mat-cell *matCellDef="let element">#{{ element?.order_code }}</td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.created_time | date : "yyyy.M.dd" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          <div
            class="status-box"
            [ngClass]="{
              'red-status': element.status == -1,
              'green-status': element.status == 6
            }"
          >
            {{ element?.status_display }}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <img
            class="pointer"
            src="assets/images/icons/eye.svg"
            alt=""
            (click)="openProductDetail(element)"
          />
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </ng-container>
</div>

<ng-template #shareLinkDialog>
  <h4>{{ "summaryPage.OrderLink" | translate }}</h4>
  <div class="link-container">
    <a [href]="shareLink" target="_blank">{{ shareLink }}</a>
    <button
      mat-icon-button
      type="button"
      [cdkCopyToClipboard]="shareLink"
      (cdkCopyToClipboardCopied)="tooltip.show()"
    >
      <mat-icon
        ><span class="material-symbols-outlined"> content_copy </span></mat-icon
      >
    </button>
    <span
      #tooltip="matTooltip"
      matTooltip="{{ 'summaryPage.copied' | translate }}"
    ></span>
  </div>
</ng-template>

<ng-template #filterOrdersBottomSheet>
  <div class="flex filter-order-wrapper">
    <div class="filter-order-container w-full">
      <div class="filter-title flex">
        <h3>Add Filter</h3>
        <div class="clear-filter pointer flex" (click)="filterForm.reset()">
          <img src="assets/images/icons/trash.svg" alt="Trash Icon" />
          <span>Clear Filters</span>
        </div>
      </div>
      <form class="filter-form" [formGroup]="filterForm">
        <div class="date-filter">
          <label>Date:</label>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [matDatepicker]="picker"
              formControlName="created_time__date"
              placeholder="Pick a Date"
            />
            <mat-datepicker-toggle matIconSuffix [for]="picker">
              <div matDatepickerToggleIcon class="flex calendar-icon">
                <span></span>
                <img src="assets/images/icons/calendar.svg" alt="" />
              </div>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </form>
    </div>
    <button
      class="button primary-button w-full"
      type="button"
      [class.disabled]="filterForm.invalid"
      (click)="filterByDate()"
    >
      Apply Filter
    </button>
  </div>
</ng-template>

<ng-template #filterOrdersDialog>
  <div class="filter-dialog-order-list">
    <div class="filter-title">
      <p>Add Filter</p>
    </div>
    <hr class="custom-hr" />
    <div class="filter-dialog-details w-full">
      <form class="filter-form" [formGroup]="filterForm">
        <div class="date-filter">
          <label>Date:</label>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [matDatepicker]="picker"
              formControlName="created_time__date"
              placeholder="Pick a Date"
            />
            <mat-datepicker-toggle matIconSuffix [for]="picker">
              <div matDatepickerToggleIcon class="flex calendar-icon">
                <span></span>
                <img src="assets/images/icons/calendar.svg" alt="" />
              </div>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </form>
    </div>
    <div class="w-full flex actions-wrapper">
      <p class="pointer cancel-button" (click)="closeDialogs()">Cancel</p>
      <button
        class="button primary-button w-full"
        type="button"
        [class.disabled]="filterForm.invalid"
        (click)="filterByDate()"
      >
        Apply Filter
      </button>
    </div>
  </div>
</ng-template>
